import getSelectedColorVariantIdVariantSelect from 'modules/variant/redux/selectors/get-selected-color-variant-id'
import hasSampledAndRatedVariantSelector from 'modules/variant/redux/selectors/has-sampled-and-rated'

const isSelectedVariantSampledAndRatedVariantSelect = state => {
  const selectedVariantId = getSelectedColorVariantIdVariantSelect(state)
  return hasSampledAndRatedVariantSelector(selectedVariantId)(state)
}

export default isSelectedVariantSampledAndRatedVariantSelect
